import * as React from "react";
// Remember that all const are suffix _svg

const close_svg = (
  <svg
    className={"close_svg"}
    role={"button"}
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.72217 37.429L37.369 2.78215" stroke="white" strokeWidth="2.08502" strokeLinecap="square" />
    <path d="M2.72217 2.72217L37.369 37.369" stroke="white" strokeWidth="2.08502" strokeLinecap="square" />
  </svg>
);

export { close_svg };
